import React from 'react';
import { motion } from 'framer-motion';
interface TCMSectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  hasDivider?: boolean;
  pattern?: 'bamboo' | 'cloud' | 'none';
}
export function TCMSection({
  children,
  className = '',
  id,
  hasDivider = false,
  pattern = 'none'
}: TCMSectionProps) {
  return <section id={id} className={`relative py-20 px-4 md:px-8 overflow-hidden ${className}`} data-id="element-51">
      {/* Decorative Background Elements */}
      {pattern === 'bamboo' && <div className="absolute right-0 top-0 bottom-0 w-32 md:w-64 opacity-5 pointer-events-none select-none" data-id="element-52">
          <svg viewBox="0 0 100 400" preserveAspectRatio="none" className="h-full w-full fill-current text-[#1a1a1a]" data-id="element-53">
            <path d="M45,0 C45,50 40,100 45,150 C50,200 45,250 48,300 C50,350 45,400 45,400 L55,400 C55,400 60,350 58,300 C55,250 60,200 55,150 C50,100 55,50 55,0 Z" data-id="element-54" />
            <path d="M40,140 L60,145 L60,155 L40,150 Z" data-id="element-55" />
            <path d="M42,290 L58,295 L58,305 L42,300 Z" data-id="element-56" />
            {/* Leaves */}
            <path d="M55,100 Q80,80 90,110 Q70,120 55,110" data-id="element-57" />
            <path d="M45,220 Q20,200 10,230 Q30,240 45,230" data-id="element-58" />
          </svg>
        </div>}

      {pattern === 'cloud' && <div className="absolute left-0 top-10 w-full h-32 opacity-5 pointer-events-none select-none" data-id="element-59">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="w-full h-full fill-current text-[#1a1a1a]" data-id="element-60">
            <path d="M0,100 C150,120 250,80 350,90 C450,100 550,60 650,80 C750,100 850,50 950,70 C1050,90 1150,60 1200,80 L1200,120 L0,120 Z" data-id="element-61" />
          </svg>
        </div>}

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-62">{children}</div>

      {hasDivider && <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-[#C8102E]/20 rounded-full" data-id="element-63" />}
    </section>;
}